import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import * as types from './EditRadProfileActionType';
import * as actions from './EditRadProfileAction';
import * as services from './EditRadProfileServices';
import SweetAlert from '../../../../components/sweetalert/SweetAlert';
import { getNavigate } from '../../../../utils/history';


// -------------------- FETCH EDIT Provider PROFILE --------------------
function* fetchEditRadProfileSaga(action) {
    try {
        const profileResponse = yield call(
            services.getRadiologistByID,
            action.payload.radiologistID
        );

        let contractSummary = "";
        // try {
        //     const summaryResponse = yield call(
        //         services.getRadiologistContractSummaryByID,
        //         action.payload.radiologistID
        //     );
        //     contractSummary = summaryResponse?.values || "";
        // } catch (_) {
        //     // endpoint not yet available; proceed without summary
        // }

        if (profileResponse?.success) {

            const data = {
                radiologistData: profileResponse.values || {},
                dropdownData: profileResponse.values || {},
                contractSummary,
            };

            yield put(actions.fetchEditRadProfileSuccess(data));

        } else {
            const errorMessage = profileResponse?.errorMessage || 'No data found';

            yield put(actions.fetchEditRadProfileFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }

    } catch (error) {

        const errorMessage = 'Failed to load Provider Profile';

        yield put(actions.fetchEditRadProfileFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE Provider PROFILE --------------------
function* saveRadSaga(action) {
    try {
        const response = yield call(
            services.saveRadiologist,
            action.payload
        );

        if (response?.success) {
            const unassignedProviderId =
                action?.payload?.UnassignedProvidersID ||
                action?.payload?.unassignedProviderId ||
                null;

            if (unassignedProviderId) {
                const assignResponse = yield call(
                    services.markUnassignedProviderAssigned,
                    {
                        UnassignedProvidersID: unassignedProviderId,
                        ModifiedBy:
                            action?.payload?.CreatedBy ||
                            action?.payload?.ModifiedBy ||
                            null,
                    },
                );

                if (!assignResponse?.success) {
                    const errorMessage =
                        assignResponse?.errorMessage ||
                        'Provider was saved, but the unassigned row could not be updated';

                    yield put(actions.saveRadFailure(errorMessage));
                    SweetAlert.error({ title: 'Error!', text: errorMessage });
                    return;
                }
            }

            const isNewProvider =
                action.payload.RadiologistID === 0 ||
                action.payload.RadiologistID === '0';
            let radiologistData;

            if (!isNewProvider) {
                // Refresh only the saved data, without navigating or unmounting the editor.
                try {
                    const profileResponse = yield call(
                        services.getRadiologistByID,
                        action.payload.RadiologistID
                    );
                    if (profileResponse?.success && profileResponse.values) {
                        radiologistData = profileResponse.values;
                    }
                } catch (error) {
                    // The save succeeded; retain the visible form if refreshing fails.
                    console.error('Failed to refresh saved Provider Profile:', error);
                }
            }

            yield put(actions.saveRadSuccess(response, radiologistData));

            // Show success message only if allowed
            if (action.showSuccessMessage !== false) {
                SweetAlert.success({
                    title: 'Success!',
                    text: response?.resultMessage || 'Saved successfully'
                });

                // Prevent unsaved-changes warning
                window.isDirty = false;

                if (isNewProvider && response.values) {
                    getNavigate()?.(
                        '/providers/edit-provider-profile/?id=' + response.values
                    );
                }
            }
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to save';

            yield put(actions.saveRadFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'An error occurred. Please try again later.';

        yield put(actions.saveRadFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- GET CITY / STATE BY ZIPCODE --------------------
function* getCityStateByZipCodeSaga(action) {
    try {
        const { zipCode, addressType } = action.payload;

        // Skip API call for incomplete zip
        if (!zipCode || zipCode.length < 5) return;

        const response = yield call(
            services.getCityStateByZipCode,
            zipCode
        );

        if (response?.success && response.values) {
            yield put(
                actions.getCityStateByZipCodeSuccess(
                    response.values,
                    addressType
                )
            );
        } else if (response?.success && response.data) {
            yield put(
                actions.getCityStateByZipCodeSuccess(
                    response.data,
                    addressType
                )
            );
        } else {
            yield put(
                actions.getCityStateByZipCodeFailure(
                    'No data found for this zip code',
                    addressType
                )
            );
        }
    } catch (error) {
        const { addressType } = action.payload;
        yield put(
            actions.getCityStateByZipCodeFailure(
                'Failed to fetch city and state',
                addressType
            )
        );
    }
}

// -------------------- SAVE RADIOLOGIST NOTE --------------------
function* saveRadNoteSaga(action) {
    try {
        const response = yield call(
            services.saveRadiologistNote,
            action.payload
        );

        if (response?.success) {
            yield put(actions.saveRadNoteSuccess(response));

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Note saved successfully'
            });

            // Refresh profile to get updated notes
            const currentUrl = new URL(window.location.href);
            const radiologistId = currentUrl.searchParams.get('id');
            if (radiologistId) {
                yield put(
                    actions.fetchEditRadProfileRequest(radiologistId)
                );
            }
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to save note';

            yield put(actions.saveRadNoteFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'An error occurred. Please try again later.';

        yield put(actions.saveRadNoteFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE RADIOLOGIST TAGS --------------------
function* saveRadTagsSaga(action) {
    try {
        const response = yield call(
            services.saveRadiologistTags,
            action.payload
        );

        if (response?.success) {
            yield put(actions.saveRadTagsSuccess(response));

            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Tags updated successfully'
            });

            if (typeof action.onSuccess === 'function') {
                action.onSuccess(response);
            }
        } else {
            const errorMessage =
                response?.errorMessage || 'Failed to save tags';

            yield put(actions.saveRadTagsFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'An error occurred while saving tags.';

        yield put(actions.saveRadTagsFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH WEEK ROTATION TEMPLATE --------------------
function* fetchWeekRotationTemplateByIdSaga(action) {
    try {
        const { weekRotationTemplateID } = action.payload;

        const response = yield call(
            services.getWeekRotationTemplateById,
            weekRotationTemplateID
        );

        if (response?.success && response.values) {
            yield put(
                actions.fetchWeekRotationTemplateByIdSuccess(
                    response.values
                )
            );
        } else {
            const errorMessage = 'No template data found';
            yield put(
                actions.fetchWeekRotationTemplateByIdFailure(
                    errorMessage
                )
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch week rotation template';

        yield put(
            actions.fetchWeekRotationTemplateByIdFailure(
                errorMessage
            )
        );
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// Get Provider Contract Documents By Contract ID

function* getRadiologistCompDocumentsByContractID(action) {
    try {

        const { contractSummaryID } = action.payload;

        if (!contractSummaryID) return;

        const response = yield call(
            services.getRadiologistContractDocumentsByContractID,
            contractSummaryID
        );

        console.log(response, "response");

        if (response?.success) {

            const contractDocumentsResponse = response.values || response.data || [];

            yield put(
                actions.fetchEditRadProfileContractDocumentsSuccess(
                    contractDocumentsResponse
                )
            );

        } else {

            const errorMessage =
                response?.errorMessage || 'No documents found for this contract id';

            yield put(
                actions.fetchEditRadProfileContractDocumentsFailure(
                    errorMessage
                )
            );

        }

    } catch (error) {

        yield put(
            actions.fetchEditRadProfileContractDocumentsFailure(
                'Failed to fetch contract documents'
            )
        );
    }
}

// -------------------- SAVE SCHEDULE WEEK ROTATION --------------------
function* saveScheduleWeekRotationSaga(action) {
    try {
        const response = yield call(
            services.saveScheduleWeekRotation,
            action.payload
        );

        if (response?.success) {
            yield put(
                actions.saveScheduleWeekRotationSuccess(
                    response.values || response
                )
            );

            if (action.showSuccessMessage !== false) {
                SweetAlert.success({
                    title: 'Success!',
                    text: 'Shift hours saved successfully.'
                });
            }
        } else {
            const errorMessage =
                response?.message || 'Failed to save shift hours';

            yield put(
                actions.saveScheduleWeekRotationFailure(errorMessage)
            );
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to save shift hours';
        yield put(
            actions.saveScheduleWeekRotationFailure(errorMessage)
        );
        SweetAlert.error({
            title: 'Error!',
            text: 'An error occurred while saving shift hours.'
        });
    }
}

//-------------Fetch Rate Card Details Saga----------------//
function* fetchRateCardDetailsByRadIdSaga(action) {
    try {
        const response = yield call(services.getRateCardDetailsByRadId, action.payload);
        if (response?.success) {
            yield put(actions.getRateCardDetailsByRadIdSuccess(response.values));
        }
        else {
            const errorMessage = response?.errorMessage || 'No data found';
            yield put(actions.getRateCardDetailsByRadIdFailure());
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to fetch Rate Card details';
        yield put(actions.getRateCardDetailsByRadIdFailure());
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH PROVIDER ASSIGNMENTS DROPDOWN --------------------
function* fetchRadAssignmentsDropdownSaga(action) {
    try {
        const response = yield call(
            services.getRadiologistAssignmentsDropdown,
            action.payload.radiologistID
        );

        if (response?.success) {
            yield put(actions.fetchRadAssignmentsDropdownSuccess(response.values || {}));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to load assignments dropdown';
            yield put(actions.fetchRadAssignmentsDropdownFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to load assignments dropdown';
        yield put(actions.fetchRadAssignmentsDropdownFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- FETCH PROVIDER ASSIGNMENTS DETAILS --------------------
function* fetchRadAssignmentsDetailsSaga(action) {
    try {
        const response = yield call(
            services.getRadiologistAssignmentsById,
            action.payload.radiologistID
        );

        if (response?.success) {
            yield put(actions.fetchRadAssignmentsDetailsSuccess(response.values || {}));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to load assignments details';
            yield put(actions.fetchRadAssignmentsDetailsFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to load assignments details';
        yield put(actions.fetchRadAssignmentsDetailsFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- SAVE PROVIDER ASSIGNMENTS --------------------
function* saveRadAssignmentsSaga(action) {
    try {
        const response = yield call(services.saveRadiologistAssignments, action.payload);

        if (response?.success) {
            yield put(actions.saveRadAssignmentsSuccess(response.values || response));
            const successText = action.mode === 'add'
                ? 'Assignment task(s) added successfully'
                : 'Assignments saved successfully';

            if (action.showSuccessMessage !== false) {
                SweetAlert.success({
                    title: 'Success!',
                    text: response?.resultMessage || successText
                });
            }

            if (typeof action.onSuccess === 'function') {
                action.onSuccess(response);
            }

            if (action.payload?.RadiologistID) {
                yield put(actions.fetchRadAssignmentsDetailsRequest(action.payload.RadiologistID));
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to save assignments';
            yield put(actions.saveRadAssignmentsFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to save assignments';
        yield put(actions.saveRadAssignmentsFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- DELETE PROVIDER ASSIGNMENT --------------------
function* deleteRadAssignmentSaga(action) {
    try {
        const response = yield call(services.deleteRadiologistAssignment, action.payload);

        if (response?.success) {
            yield put(actions.deleteRadAssignmentSuccess(response.values || response));
            SweetAlert.success({
                title: 'Success!',
                text: response?.resultMessage || 'Assignment deleted successfully'
            });

            if (typeof action.onSuccess === 'function') {
                action.onSuccess();
            }
        } else {
            const errorMessage = response?.errorMessage || 'Failed to delete assignment';
            yield put(actions.deleteRadAssignmentFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to delete assignment';
        yield put(actions.deleteRadAssignmentFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}

// -------------------- RAD DOCUMENT TYPES --------------------
function* fetchRadDocumentTypesSaga() {
    try {
        const response = yield call(services.getRadDocumentTypes);
        if (response?.success) {
            yield put(actions.fetchRadDocumentTypesSuccess(response.values?.listRadDocType || []));
        } else {
            yield put(actions.fetchRadDocumentTypesFailure('Failed to load document types'));
        }
    } catch (error) {
        yield put(actions.fetchRadDocumentTypesFailure('Failed to load document types'));
    }
}

// -------------------- RAD DOCUMENT MANAGEMENT --------------------
function* fetchRadDocumentsSaga(action) {
    try {
        const response = yield call(services.getRadDocumentsByRadId, action.payload);
        if (response?.success) {
            yield put(actions.fetchRadDocumentsSuccess(response.values || []));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to load documents';
            yield put(actions.fetchRadDocumentsFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        yield put(actions.fetchRadDocumentsFailure('Failed to load documents'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to load documents' });
    }
}

function* uploadRadDocumentSaga(action) {
    try {
        const { formData, radiologistId, onSuccess } = action.payload;
        const response = yield call(services.uploadRadDocument, formData);
        if (response?.success) {
            yield put(actions.uploadRadDocumentSuccess(response));
            if (typeof onSuccess === 'function') onSuccess();
            SweetAlert.success({ title: 'Success!', text: response?.resultMessage || 'Document uploaded successfully' });
            yield put(actions.fetchRadDocumentsRequest({ RadiologistId: radiologistId }));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to upload document';
            yield put(actions.uploadRadDocumentFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        yield put(actions.uploadRadDocumentFailure('Failed to upload document'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to upload document' });
    }
}

function* deleteRadDocumentSaga(action) {
    try {
        const response = yield call(services.deleteRadDocument, action.payload);
        if (response?.success) {
            yield put(actions.deleteRadDocumentSuccess(response));
            SweetAlert.success({ title: 'Success!', text: response?.resultMessage || 'Document deleted successfully' });
            yield put(actions.fetchRadDocumentsRequest({ RadiologistId: action.payload.RadiologistId }));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to delete document';
            yield put(actions.deleteRadDocumentFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        yield put(actions.deleteRadDocumentFailure('Failed to delete document'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to delete document' });
    }
}

function* downloadRadDocumentSaga(action) {
    try {
        const response = yield call(services.downloadRadDocument, action.payload);
        if (response?.values) {
            yield put(actions.downloadRadDocumentSuccess(response.values));
            if (typeof action.onSuccess === 'function') action.onSuccess(response.values);
        } else {
            const errorMessage = response?.errorMessage || 'Failed to download document';
            yield put(actions.downloadRadDocumentFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        yield put(actions.downloadRadDocumentFailure('Failed to download document'));
        SweetAlert.error({ title: 'Error!', text: 'Failed to download document' });
    }
}

// -------------------- ROOT SAGA --------------------
export default function* editradprofileSaga() {
    yield takeEvery(
        types.FETCH_EDITRAD_PROFILE_REQUEST,
        fetchEditRadProfileSaga
    );
    yield takeLeading(types.SAVE_RAD_REQUEST, saveRadSaga);
    yield takeEvery(
        types.GET_CITY_STATE_BY_ZIPCODE_REQUEST,
        getCityStateByZipCodeSaga
    );
    yield takeEvery(types.SAVE_RAD_NOTE_REQUEST, saveRadNoteSaga);
    yield takeEvery(types.SAVE_RAD_TAGS_REQUEST, saveRadTagsSaga);
    yield takeEvery(
        types.FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST_RADPROFILE,
        fetchWeekRotationTemplateByIdSaga
    );
    yield takeEvery(
        types.SAVE_SCHEDULE_WEEK_ROTATION_REQUEST,
        saveScheduleWeekRotationSaga
    );
    yield takeEvery(
        types.GET_RATE_CARD_DETAILS_BY_RAD_ID_REQUEST,
        fetchRateCardDetailsByRadIdSaga
    );
    yield takeEvery(
        types.FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_REQUEST,
        getRadiologistCompDocumentsByContractID
    );
    yield takeEvery(
        types.FETCH_RAD_ASSIGNMENTS_DROPDOWN_REQUEST,
        fetchRadAssignmentsDropdownSaga
    );
    yield takeEvery(
        types.FETCH_RAD_ASSIGNMENTS_DETAILS_REQUEST,
        fetchRadAssignmentsDetailsSaga
    );
    yield takeEvery(
        types.SAVE_RAD_ASSIGNMENTS_REQUEST,
        saveRadAssignmentsSaga
    );
    yield takeEvery(
        types.DELETE_RAD_ASSIGNMENT_REQUEST,
        deleteRadAssignmentSaga
    );
    yield takeEvery(types.FETCH_RAD_DOCUMENT_TYPES_REQUEST, fetchRadDocumentTypesSaga);
    yield takeEvery(types.FETCH_RAD_DOCUMENTS_REQUEST, fetchRadDocumentsSaga);
    yield takeEvery(types.UPLOAD_RAD_DOCUMENT_REQUEST, uploadRadDocumentSaga);
    yield takeEvery(types.DELETE_RAD_DOCUMENT_REQUEST, deleteRadDocumentSaga);
    yield takeEvery(types.DOWNLOAD_RAD_DOCUMENT_REQUEST, downloadRadDocumentSaga);
    yield takeEvery(types.FETCH_RAD_NOTE_TYPES_REQUEST, fetchRadNoteTypesSaga);
    yield takeEvery(
        types.FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_REQUEST,
        fetchActiveHomeStateLicenseDropdownSaga
    );
}

// -------------------- RAD NOTE TYPES --------------------
function* fetchRadNoteTypesSaga() {
    try {
        const response = yield call(services.getRadNoteTypes);
        if (response?.success) {
            yield put(actions.fetchRadNoteTypesSuccess(response.values?.listRadNoteType || []));
        } else {
            yield put(actions.fetchRadNoteTypesFailure('Failed to load note types'));
        }
    } catch (error) {
        yield put(actions.fetchRadNoteTypesFailure('Failed to load note types'));
    }
}

// -------------------- FETCH ACTIVE HOME STATE LICENSE DROPDOWN --------------------
function* fetchActiveHomeStateLicenseDropdownSaga(action) {
    try {
        const response = yield call(
            services.getActiveHomeStateLicenseDropdown,
            action.payload.radiologistID
        );

        if (response?.success) {
            yield put(actions.fetchActiveHomeStateLicenseDropdownSuccess(response.values || []));
        } else {
            const errorMessage = response?.errorMessage || 'Failed to load active home state license dropdown';
            yield put(actions.fetchActiveHomeStateLicenseDropdownFailure(errorMessage));
            SweetAlert.error({ title: 'Error!', text: errorMessage });
        }
    } catch (error) {
        const errorMessage = 'Failed to load active home state license dropdown';
        yield put(actions.fetchActiveHomeStateLicenseDropdownFailure(errorMessage));
        SweetAlert.error({ title: 'Error!', text: errorMessage });
    }
}
